import emojiConfig from './source/data/emojiConfig'

/**
 * @description: 表情映射表
 */
const emojiMap = generateEmojiMap()
function generateEmojiMap() {
  let map = {}
  for (let i = 0; i <= emojiConfig.length - 1; i++) {
    let emojiItem = emojiConfig[i]
    let emojiKey = emojiConfig[i].value
    map[emojiKey] = emojiItem
  }
  return map
}

/**
 * @description: 替换字符串中匹配到的表情编码 [Drool] => <i class="emoji-icon-drool"></i>
 */
export default function (str) {
  if (!str) return ''
  let reg = /\[(.+?)\]/g
  return str.replace(reg, (v1, v2, idx) => {
    if (emojiMap[v2]) {
      return `<i class="emoji-icon emoji-icon-${emojiMap[v2].icon}"></i>`
    } else {
      return v1
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/emoji-input/decodeEmoji.js